import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AppButtonSize,
  AppButtonType,
  DialogData,
} from 'src/app/core/models/common-components.model';

@Component({
  selector: 'app-dialog',
  templateUrl: './app-dialog.component.html',
  styleUrl: './app-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppDialogComponent {
  public btnTypes = AppButtonType;
  public btnSizes = AppButtonSize;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<AppDialogComponent>,
  ) {}

  public close(action: string): void {
    this.dialogRef.close(action);
  }
}
